<template>
  <div id="contenedor-main-infraestructura-configuracion-subtipos-infraestructura">
    <tool-bar
      v-on:nuevoSubtipoInfraestructura="agregarNuevoSubtipoInfraestructura">
    </tool-bar>
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <listado
            :listadoSubtiposInfraestructura="getSubtiposInfraestructura">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Ventana Agregar Subtipo Infraestructura -->
    <v-dialog
      v-if="mostrarVentanaAgregarSubtipoInfraestructura"
      v-model="mostrarVentanaAgregarSubtipoInfraestructura"
      persistent
      width="600">
      <agregar-subtipo-infraestructura
      v-on:cerrar="cerrarVentana">
      </agregar-subtipo-infraestructura>
    </v-dialog>
    <!-- Ventana Editar Subtipo Infraestructura -->
    <v-dialog
      v-if="esteSubtipoInfraestructura"
      v-model="mostrarVentanaEditarSubtipoInfraestructura"
      scrollable
      persistent
      width="600">
      <editar-subtipo-infraestructura
      :subtipoInfraestructuraEditar="esteSubtipoInfraestructura"
      v-on:cerrar="cerrarVentana">
      </editar-subtipo-infraestructura>
    </v-dialog>
    <!-- Ventana Eliminar Subtipo Infraestructura -->
    <v-dialog
      v-if="esteSubtipoInfraestructura"
      v-model="mostrarVentanaEiminarSubtipoInfraestructura"
      scrollable
      persistent
      width="400">
      <eliminar-subtipo-infraestructura
      :subtipoInfraestructuraEliminar="esteSubtipoInfraestructura"
      v-on:cerrar="cerrarVentana">
      </eliminar-subtipo-infraestructura>
    </v-dialog>
  </div>
</template>

<script>
import CATALOGO_INFRAESTRUCTURA_SUBTIPOS from '@/graphql/querys/administracion/catalogos/infraestructurasubtipos/catalogoInfraestructuraSubtipos.gql';
import ToolBar from './ToolBar.vue';
// import CustomButton from '@/components/buttons/Button.vue';
import AgregarSubtipoInfraestructura from '@/components/administracion/infraestructura/configuracion/subtiposinfraestructura/Nuevo.vue';
import EditarSubtipoInfraestructura from '@/components/administracion/infraestructura/configuracion/subtiposinfraestructura/Editar.vue';
import EliminarSubtipoInfraestructura from '@/components/administracion/infraestructura/configuracion/subtiposinfraestructura/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainInfraestructuraConfiguracionSubtiposInfraestructura',
  components: {
    ToolBar,
    AgregarSubtipoInfraestructura,
    EditarSubtipoInfraestructura,
    EliminarSubtipoInfraestructura,
    Listado,
  },
  data() {
    return {
      mostrarVentanaAgregarSubtipoInfraestructura: false,
      mostrarVentanaEditarSubtipoInfraestructura: false,
      mostrarVentanaEiminarSubtipoInfraestructura: false,
      esteSubtipoInfraestructura: null,
    };
  },
  mounted() {
    eventBus.$on('editar-subtipo-infraestructura', (subtipoInfraestructura) => {
      this.mostrarVentanaEditarSubtipoInfraestructura = true;
      this.esteSubtipoInfraestructura = subtipoInfraestructura;
    });
    eventBus.$on('eliminar-subtipo-infraestructura', (subtipoInfraestructura) => {
      this.mostrarVentanaEiminarSubtipoInfraestructura = true;
      this.esteSubtipoInfraestructura = subtipoInfraestructura;
    });
  },
  methods: {
    cerrarVentana() {
      this.mostrarVentanaAgregarSubtipoInfraestructura = false;
      this.mostrarVentanaEditarSubtipoInfraestructura = false;
      this.mostrarVentanaEiminarSubtipoInfraestructura = false;
      this.esteSubtipoInfraestructura = null;
    },
    agregarNuevoSubtipoInfraestructura() {
      this.mostrarVentanaAgregarSubtipoInfraestructura = true;
    },
  },
  apollo: {
    catalogoInfraestructuraSubtipos: {
      query: CATALOGO_INFRAESTRUCTURA_SUBTIPOS,
    },
  },
  computed: {
    getSubtiposInfraestructura() {
      if (!this.catalogoInfraestructuraSubtipos) return [];
      return this.catalogoInfraestructuraSubtipos;
    },
  },
};
</script>

<style lang="scss">

</style>
